import React from 'react';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the People list and the details panel */
import styles from './People.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The match score of a person (0-100) as a small ring (design outreach-v2 t1). */
const FitRingComponent: React.FC<{ score: number; label: string }> = ({ score, label }) => (
  <span
    className={styles.fit}
    // The ring fills to the score: a value of the row, not a style of the design.
    style={{
      background: `conic-gradient(var(--brand-violet-lift) ${Math.min(100, Math.max(0, score))}%, var(--bg-3) 0)`,
    }}
    title={label}
    aria-label={label}
  >
    <b className={styles.fitValue}>{score}</b>
  </span>
);

export const FitRing = TypedMemo(FitRingComponent);
